/*
 *  拍照弹框
 **/
import CameraUtil from "@/util/CameraUtil";
import { HudGlobal } from "@/util/HudGlobal";
import DateUtil from "@/util/DateUtil";

export default {
    name: "TakePhotoDialog.vue",
    props: {
        /**
         * 是否显示 默认 false
         */
        fileName: {
            type: String,
        },
        // 关闭窗口时, 不关闭摄像头, 会影响其它页面
        closeCamera: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isCloseCamera: true,
            inVisible: false,
            photoObject: null,
            isReTake: false, //是否重新拍照
            imgTipList: [
                {
                    label: "面部不全",
                    img: require("@assets/img/takePhoto/img_tip2.png"),
                },
                {
                    label: "图像模糊",
                    img: require("@assets/img/takePhoto/img_tip3.png"),
                },
                {
                    label: "光线不当",
                    img: require("@assets/img/takePhoto/img_tip4.png"),
                },
                {
                    label: "面部遮挡",
                    img: require("@assets/img/takePhoto/img_tip5.png"),
                },
            ],
        };
    },
    created() {
        this.isCloseCamera = this.closeCamera;
        this.isReTake = false;
    },
    mounted() {},
    methods: {
        opened() {
            if (!this.isReTake) {
                // 必须在挂载的时候使用
                this.setupInitCamera();
            }
        },
        onTakeCamera() {
            if (this.isReTake) {
                // 重拍
                this.onClickReTakeEvent();
            } else {
                // 拍照
                this.onClickTakePhotoEvent();
            }
        },
        /**
         *
         *  点击拍照
         * */
        onClickTakePhotoEvent() {
            const that = this;
            let dateFtt = DateUtil.dateFtt("yyyyMMddhhmmss", new Date());

            const fileName = this.fileName || dateFtt;
            CameraUtil.takeCameraSnapWithFileName(fileName).then((response) => {
                that.photoObject = response;
                that.isReTake = true;
                //显示照片
                let cameraUploadBox = document.getElementById("camera-photo");
                cameraUploadBox.innerHTML = "";
                cameraUploadBox.innerHTML = '<img src="' + response.base64 + '"/>';
            });
        },
        show() {
            this.inVisible = true;
        },
        hide() {
            this.inVisible = false;
        },
        /**
         *  重新拍照
         * */
        onClickReTakeEvent() {
            this.resetReTakeData();
            this.setupInitCamera();
        },
        /**
         *  复位照相机
         * */
        resetReTakeData() {
            document.getElementById("camera-upload-box").innerHTML = "";
            this.isReTake = false;
        },

        /**
         * 关闭弹框
         */
        onCloseDialogEvent() {
            if (this.isCloseCamera) {
                CameraUtil.closeCamera();
                this.$emit("closeDialogCamera");
            }

            this.hide();
            this.$emit("call-back", { type: 0, data: null });
            this.resetReTakeData();
        },

        /**
         *  点击确定按钮
         */
        onClickEnsureEvent() {
            if (this.photoObject == null) {
                HudGlobal.showWarningWithMessage("请完成拍照");
                return;
            }
            this.onCloseDialogEvent();
            this.$emit("call-back", { type: 1, data: this.photoObject });
            this.resetReTakeData();
        },
        /*
         *  初始化相机
         * */
        setupInitCamera() {
            const width = 260;
            const height = 340;
            CameraUtil.resetCamera();
            CameraUtil.initWithCamera("camera-upload-box", width, height);
            this.photoObject = null;
        },
    },
    watch: {},
};
